(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["yula-testimonials"] && !Shopify.designMode) return;
  try {
    (function(){
  function scrollToTarget(hash,updateHistory){
    if(!hash||hash==='#')return false;
    var target;
    try{target=document.querySelector(hash);}catch(error){return false;}
    if(!target)return false;
    target.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});
    if(updateHistory)history.pushState(null,'',hash);
    return true;
  }
  if(window.yulaSmoothScrollBound)return;
  window.yulaSmoothScrollBound=true;
  document.addEventListener('click',function(event){
    var link=event.target.closest('a[href*="#"]');
    if(!link||event.defaultPrevented||event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
    var url;
    try{url=new URL(link.href,window.location.href);}catch(error){return;}
    if(url.origin!==window.location.origin||!url.hash)return;
    if(url.pathname===window.location.pathname&&url.search===window.location.search){
      if(scrollToTarget(url.hash,false)){
        event.preventDefault();
        history.pushState(null,'',url.hash);
      }
      return;
    }
    event.preventDefault();
    sessionStorage.setItem('yulaScrollTarget',url.hash);
    window.location.assign(url.pathname+url.search);
  });
  var pendingTarget=sessionStorage.getItem('yulaScrollTarget');
  if(pendingTarget){
    sessionStorage.removeItem('yulaScrollTarget');
    requestAnimationFrame(function(){requestAnimationFrame(function(){scrollToTarget(pendingTarget,true);});});
  }
})();
document.querySelectorAll('[data-yula-testimonials]').forEach(function(section){
  var track=section.querySelector('.yula-testimonials__track');
  var viewport=section.querySelector('.yula-testimonials__viewport');
  var originals=Array.from(section.querySelectorAll('[data-testimonial]'));
  var dots=section.querySelectorAll('.yula-testimonials__dots button');
  if(originals.length<2)return;
  var firstClone=originals[0].cloneNode(true);
  var lastClone=originals[originals.length-1].cloneNode(true);
  firstClone.setAttribute('aria-hidden','true');
  lastClone.setAttribute('aria-hidden','true');
  track.insertBefore(lastClone,originals[0]);
  track.appendChild(firstClone);
  var index=1;
  function logicalIndex(){return(index-1+originals.length)%originals.length;}
  function position(animate){
    var cards=track.children;
    var card=cards[index];
    track.style.transition=animate?'transform .5s cubic-bezier(.22,.7,.24,1)':'none';
    track.style.transform='translate3d('+(viewport.clientWidth/2-card.offsetLeft-card.offsetWidth/2)+'px,0,0)';
    Array.from(cards).forEach(function(item,i){item.classList.toggle('is-active',i===index);});
    dots.forEach(function(dot,i){dot.classList.toggle('is-active',i===logicalIndex());});
  }
  function show(next){index=next;position(true);}
  track.addEventListener('transitionend',function(event){
    if(event.propertyName!=='transform')return;
    if(index===0){index=originals.length;position(false);}
    if(index===originals.length+1){index=1;position(false);}
  });
  section.querySelector('.yula-testimonials__arrow--prev').addEventListener('click',function(){show(index-1);});
  section.querySelector('.yula-testimonials__arrow--next').addEventListener('click',function(){show(index+1);});
  dots.forEach(function(dot,i){dot.addEventListener('click',function(){show(i+1);});});
  window.addEventListener('resize',function(){position(false);});
  position(false);
});
  } catch(e) { console.error(e); }
})();

})();
